import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import globalStyles from '../../form.module.css';
import styles from '../inputs.module.css';

const InputRequired = ({
  formErrors,
  captureFieldData,
  theme,
  name,
  placeholder,
  type,
}) => {
  const handleCaptureData = event => {
    captureFieldData(event);
  };

  return (
    <React.Fragment>
      <input
        id={name}
        name={name}
        placeholder={
          typeof formErrors === 'undefined' || formErrors.length === 0
            ? placeholder
            : formErrors
        }
        type={type}
        className={
          typeof formErrors === 'undefined' || formErrors.length === 0
            ? [
                css`
                  color: ${theme};
                  ::placeholder {
                    color: ${theme};
                  }
                `,
                styles.input,
                globalStyles.input,
              ].join(' ')
            : [
                styles.input,
                globalStyles.input,
                css`
                  border-color: #d0021b;
                  color: ${theme};
                  ::placeholder {
                    color: #d0021b;
                  }
                `,
              ].join(' ')
        }
        onChange={event => handleCaptureData(event)}
      />
    </React.Fragment>
  );
};

InputRequired.propTypes = {
  formErrors: PropTypes.string,
  captureFieldData: PropTypes.func,
  theme: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
};

export default InputRequired;



// WEBPACK FOOTER //
// ./src/components/form/inputs/input-required/index.js